class Navigation {
    constructor() {
        this.cacheDom();
        this.bindEvents();
        this.resize();
    }

    cacheDom() {
        this.body = document.body;
        this.masthead = document.querySelector('.l-masthead');
        this.trigger = document.querySelector('.c-navigation__trigger');
        this.navigation = document.querySelector('.c-navigation');
        this.dropdown = document.querySelector('.c-navigation__dropDown');
    }
    
    bindEvents() {
        if (_.isNull(this.trigger) === false) {
            this.trigger.addEventListener('click', (e) => {
                e.preventDefault();

                this.body.classList.toggle('u-overflow-hidden');
                this.trigger.classList.toggle('c-navigation__trigger--open');
                this.navigation.classList.toggle('c-navigation--open');
            });
        }
    }

    resize() {
        if (_.isUndefined(Breakpoint) === false) {
            if (Breakpoint.grpInt > 3) {
               this.hideShowHeader();
            }
        }
    }

    hideShowHeader() {
        // construct an instance of Headroom, passing the element
        const headroom = new Headroom(this.masthead);
        // initialise
        //headroom.init(); 
    }
}

module.exports = Navigation;